<div class="rounded-3 bg-white p-8 text-primary shadow-2">
  <h3>{{ title }}</h3>
  <div>{{ description }}</div>
  <div class="mt-6">
    <ng-content></ng-content>
  </div>
  @if (buttonText) {
    <div class="mt-6">
      <button class="btn btn-hero" type="button" (click)="buttonClick.emit()" cft-button [isLoading$]="isLoading$">
        {{ buttonText }}
        @if (buttonIcon) {
          <fa-icon [icon]="buttonIcon" class="btn-right-icon"></fa-icon>
        }
      </button>
      @if (buttonHint) {
        <div [innerHTML]="buttonHint" class="button-hint mt-md text-sm text-president-200"></div>
      }
    </div>
  }
</div>
